import React, { useEffect, useState } from 'react'
import { AttachmentsForm } from '@Root/components'
import { useDispatch, useSelector } from 'react-redux'
import { contactAttachmentActions, contactAttachmentSelectors } from '@Store/contact'
import { contactSelectors } from '@Root/store'
import { Redirect } from 'react-router'

const PARENT_URL = '/home/contacts/all-contacts'
export const ContactsAttachmentsForm = ({ contactId }) => {
  const dispatch = useDispatch()
  const isLoading = useSelector(contactAttachmentSelectors.isLoading)
  const isSuccess = useSelector(contactAttachmentSelectors.isSuccess)
  const attachments = useSelector(contactAttachmentSelectors.attachments)
  const permissions = useSelector(contactAttachmentSelectors.permissions)
  const history = useSelector(contactAttachmentSelectors.history)
  const totalHistory = useSelector(contactAttachmentSelectors.totalHistory)
  const contactPermissions = useSelector(contactSelectors.permissions)
  const totalAttachments = useSelector(contactAttachmentSelectors.totalAttachments)
  const [page, setPage] = useState(1)
  const [openIdHistoryOfChanges, setOpenIdHistoryOfChanges] = useState(null)
  const [pageHistory, setPageHistory] = useState(1)

  useEffect(() => {
    dispatch(contactAttachmentActions.get({ id: contactId, page }))
    return () => {
      dispatch(contactAttachmentActions.resetAttachments())
    }
  }, [dispatch, contactId])

  const onCreate = payload => {
    dispatch(contactAttachmentActions.create({ ...payload, contact_id: contactId }))
  }

  const onEdit = (id, payload) => {
    dispatch(contactAttachmentActions.edit({ id, data: { ...payload, contact_id: contactId } }))
  }

  const onDelete = id => {
    dispatch(contactAttachmentActions.delete(id))
  }

  if (!contactPermissions.tabs?.attachment) return <Redirect to={PARENT_URL} />

  const handelPaginationAttachmentAction = () => {
    setPage(page + 1)
    dispatch(contactAttachmentActions.get({ id: contactId, page: page + 1 }))
  }

  const onOpenHistoryOfChanges = id => {
    dispatch(contactAttachmentActions.getHistory({ id, pageHistory }))
    setOpenIdHistoryOfChanges(id)
  }

  const clearHistory = () => {
    dispatch(contactAttachmentActions.clearHistory())
    setPageHistory(1)
  }
  const historyPaginate = () => {
    setPageHistory(pageHistory + 1)
    dispatch(contactAttachmentActions.getHistory({ id: openIdHistoryOfChanges, page: pageHistory + 1 }))
  }
  return (
    <AttachmentsForm
      canManipulate
      canCreate={permissions?.create}
      initialValues={attachments}
      onCreate={onCreate}
      onDelete={onDelete}
      onEdit={onEdit}
      isLoading={isLoading}
      isSuccess={isSuccess}
      history={history}
      totalHistory={totalHistory}
      totalAttachments={totalAttachments}
      handelPaginationAttachmentAction={handelPaginationAttachmentAction}
      onOpenHistoryOfChanges={onOpenHistoryOfChanges}
      clearHistory={clearHistory}
      historyPaginate={historyPaginate}
    />
  )
}
